import { useEffect } from 'react';
import { sendPresence } from '../api/candidate';

/** Rythme du signal ; le serveur tient pour « en ligne » un signal de moins de 75 secondes. */
export const PRESENCE_HEARTBEAT_MS = 30_000;
/** Sans toucher à l'espace depuis 15 minutes, l'élève n'est plus « en ligne ». */
const ACTIVE_WINDOW_MS = 15 * 60_000;
/** Deux signaux à moins de 10 secondes n'apprennent rien au serveur (double montage, retour sur la page). */
const MIN_GAP_MS = 10_000;
let lastSent = 0;

let lastActivity = Date.now();
const markActive = () => {
  lastActivity = Date.now();
};

/**
 * Signal de présence de l'élève connecté, tant que son espace est visible et utilisé. Espace
 * caché ou délaissé : plus de signal, l'élève passe hors ligne de lui-même. Un échec n'est jamais
 * montré.
 */
export function usePresenceHeartbeat(enabled = true) {
  useEffect(() => {
    if (!enabled) return;
    const events = ['pointerdown', 'keydown', 'touchstart', 'scroll'] as const;
    for (const name of events)
      window.addEventListener(name, markActive, { passive: true });
    const beat = () => {
      if (
        document.visibilityState !== 'visible' ||
        Date.now() - lastActivity > ACTIVE_WINDOW_MS
      )
        return;
      if (Date.now() - lastSent < MIN_GAP_MS) return;
      lastSent = Date.now();
      sendPresence().catch(() => undefined);
    };
    beat();
    const timer = window.setInterval(beat, PRESENCE_HEARTBEAT_MS);
    const onVisible = () => {
      if (document.visibilityState === 'visible') {
        markActive();
        beat();
      }
    };
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      window.clearInterval(timer);
      document.removeEventListener('visibilitychange', onVisible);
      for (const name of events) window.removeEventListener(name, markActive);
    };
  }, [enabled]);
}
